import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { updateShowWidenModal } from "../../redux/reducers/widenSearchSlice";
import { assetConstructor } from "../../utils/assetConstructor";
import { ModalLayout, ModalBody, ModalHeader, ModalFooter } from '@strapi/design-system/ModalLayout';
import { Typography } from "@strapi/design-system/Typography";
import { Box } from '@strapi/design-system/Box';
import { Button } from '@strapi/design-system/Button';
import styles from './PreviewModal.module.css';
import { FILE_TYPE, PREVIEW_MODAL_CANCEL_BUTTON_TEXT, PREVIEW_MODAL_INSERT_BUTTON_TEXT, PREVIEW_MODAL_LABEL_FILE_NAME, PREVIEW_MODAL_LABEL_TITLE, PREVIEW_MODAL_TITLE } from '../../utils/constants';
import { isDocumentLikeFileType } from '../../utils/fileTypes';
const PreviewModal = ({
  setModalVisible,
  modalData,
  onSelect
}) => {
  const dispatch = useDispatch();
  const {
    showWidenModal
  } = useSelector(state => state.widenSearch);
  const [showEmptyImage, setShowEmptyImage] = useState(false);
  const [showSpinner, setShowSpinner] = useState(true);
  const asset = assetConstructor(modalData.item);
  const handleClosePreviewModal = () => {
    setModalVisible(prev => !prev);
    dispatch(updateShowWidenModal(!showWidenModal));
  };
  const createMarkup = () => {
    return {
      __html: asset?.embed_code
    };
  };
  return /*#__PURE__*/React.createElement(ModalLayout, {
    onClose: handleClosePreviewModal,
    labelledBy: "title",
    className: styles["modal-layout"]
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(Typography, {
    fontWeight: "bold",
    textColor: "neutral800",
    as: "h2",
    id: "title"
  }, PREVIEW_MODAL_TITLE)), /*#__PURE__*/React.createElement(ModalBody, {
    className: styles["body-container"]
  }, /*#__PURE__*/React.createElement(Box, {
    padding: 0,
    className: styles["preview-container"]
  }, (modalData.filetype === FILE_TYPE.video || modalData.filetype === FILE_TYPE.audio) && /*#__PURE__*/React.createElement("div", {
    className: styles['embedWidenContainer'],
    dangerouslySetInnerHTML: createMarkup()
  }), modalData.filetype === FILE_TYPE.image && /*#__PURE__*/React.createElement("div", {
    className: styles['embedWidenContainer-image'],
    dangerouslySetInnerHTML: createMarkup()
  }), isDocumentLikeFileType(modalData.filetype) && /*#__PURE__*/React.createElement("div", {
    className: styles['embedWidenContainer-document'],
    dangerouslySetInnerHTML: createMarkup()
  })), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
    textColor: "neutral800",
    variant: "pi",
    fontWeight: "bold",
    as: "label",
    className: styles["label"]
  }, PREVIEW_MODAL_LABEL_TITLE), /*#__PURE__*/React.createElement(Box, {
    padding: 2,
    background: "neutral000",
    borderColor: "neutral200",
    className: styles["text-container"]
  }, /*#__PURE__*/React.createElement(Typography, {
    textColor: "neutral800",
    ellipsis: true
  }, modalData.title)), /*#__PURE__*/React.createElement(Typography, {
    textColor: "neutral800",
    variant: "pi",
    fontWeight: "bold",
    as: "label",
    className: styles["label"]
  }, PREVIEW_MODAL_LABEL_FILE_NAME), /*#__PURE__*/React.createElement(Box, {
    padding: 2,
    background: "neutral000",
    borderColor: "neutral200",
    className: styles["text-container"]
  }, /*#__PURE__*/React.createElement(Typography, {
    textColor: "neutral500",
    variant: "pi",
    ellipsis: true
  }, modalData.fileName)))), /*#__PURE__*/React.createElement(ModalFooter, {
    startActions: /*#__PURE__*/React.createElement(Button, {
      onClick: handleClosePreviewModal,
      variant: "tertiary"
    }, PREVIEW_MODAL_CANCEL_BUTTON_TEXT),
    endActions: /*#__PURE__*/React.createElement(Button, {
      onClick: () => onSelect(modalData.item)
    }, " ", PREVIEW_MODAL_INSERT_BUTTON_TEXT)
  }));
};
export default PreviewModal;